<template>
  <div class="section-row tx-odu-partnumbersearch">
    <router-view/>
    <OverlayItem></OverlayItem>
    <CartBadge></CartBadge>
  </div>

</template>
<script>
import OverlayItem from '@/components/OverlayItem'
import CartBadge from '@/components/CartBadge'

export default {
  components: { CartBadge, OverlayItem }
}
</script>